import { render } from "./WYSIWYG.vue?vue&type=template&id=3ee0b3c7"
import script from "./WYSIWYG.vue?vue&type=script&lang=js"
export * from "./WYSIWYG.vue?vue&type=script&lang=js"

import "./WYSIWYG.vue?vue&type=style&index=0&id=3ee0b3c7&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__